'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "httpClient", "onError", "onSuccess", "trimInputValue", "type", "requireProtocol", "requireHttps", "validationMessage", "validateDefaultValue"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import http from 'hub-http/clients/apiClient';
import { propTypes } from '../core/UIValidatedFormControl/UIValidatedFormControlPropsInterface';
import UIValidatedFormControl from 'ui-addon-form-validation/core/UIValidatedFormControl/UIValidatedFormControl';
import urlMessageDefaults from './urlMessageDefaults';
import { urlValidationTypes } from './urlValidationConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export default class UIValidatedUrlFormControl extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        httpClient = http,
        onError,
        onSuccess,
        trimInputValue = false,
        type = urlValidationTypes.basic,
        requireProtocol = false,
        requireHttps = false,
        validationMessage = urlMessageDefaults,
        validateDefaultValue = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIValidatedFormControl, Object.assign({}, rest, {
      trimInputValue: trimInputValue,
      validator: "url",
      validationMessage: validationMessage,
      validateDefaultValue: validateDefaultValue,
      validationOpts: {
        type,
        httpClient,
        requireProtocol,
        requireHttps
      },
      onSuccess: onSuccess,
      onError: onError,
      children: children
    }));
  }
}
UIValidatedUrlFormControl.propTypes = Object.assign({}, propTypes, {
  type: PropTypes.oneOf(Object.keys(urlValidationTypes)),
  httpClient: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  requireProtocol: PropTypes.bool,
  requireHttps: PropTypes.bool,
  value: PropTypes.string
});